import React, {useEffect, useRef, useState} from 'react';
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";
import responseHandler from "../../../services/responseHandler";

function PackagesList(props) {
    const axiosPrivate = useAxiosIntercept();
    const [packageData, setPackageData] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState(props.selectedPackage? props.selectedPackage : {});
    const ref = useRef(true);
    const [isOpen, setIsOpen] = useState(false);
    const getPackageList = async () => {
        try{
            let payload={};
            payload.status= 1;
            payload.brand_id = props.selectedBrandId;
            payload.model_id = props.selectedModelId;
            payload.variant_id = props.selectedVariantId;
            const response = await axiosPrivate.post(process.env.REACT_APP_GET_PACKAGES_URL, payload);
            if(response?.data?.status == 200){
                if(response?.data?.response?.data?.packages){
                    setPackageData(response?.data?.response?.data?.packages);
                }
            }
            else{
                console.log(`API Error: ${JSON.stringify(response?.data?.response)}`);
            }
        }
        catch (error){
            return responseHandler(error, "NETWORK_ERROR");
        }
    }

    useEffect(()=>{
        if(ref.current){
            ref.current= false;
            getPackageList();
        }
    },[])

    return(
        <div className="fieldGroup">
            <label>Assign a package</label>
            <div className="multiOption">
                {/*<div className={showDrop ? "selectBox fullW open" : "selectBox fullW"} onClick={()=>{setShowDrop(prev => !prev)}}>*/}
                <div className={isOpen ? "selectBox fullW open" : "selectBox fullW"} >
                    {   selectedPackage.id ?
                        <p onClick = {()=>{setIsOpen(prevState => !prevState)}}>
                            {selectedPackage.name}
                            <i className="material-symbols-rounded grey">expand_more</i>
                        </p>
                        :
                        <p onClick = {()=>{setIsOpen(prevState => !prevState)}}>
                            Select package{" "}
                            <i className="material-symbols-rounded grey">expand_more</i>
                        </p>
                    }
                    <div className="selectDrop">
                        <ul className="dropMenu">
                            {
                                packageData.map((data) => {
                                    return(
                                        <li onClick={()=>{setSelectedPackage({"id" : data.package_id, "name" : data.package_name}); setIsOpen(prevState => !prevState); props.setSelectedPackage({"id" : data.package_id, "name" : data.package_name})}} className="selected" key={data.package_id}>
                                            <a href={void(0)}>
                                                {data.package_name}
                                                {data.package_id == selectedPackage.id && <i className="material-symbols-rounded">done</i>}
                                            </a>
                                        </li>
                                    )
                                })

                            }

                        </ul>
                    </div>


                </div>
            </div>
        </div>

    );

    // return (
    //     <select value={selectedOption} onChange={onChangeSelectedItem}>
    //         {
    //             packageData.map((data)=>{
    //                 return (
    //                     <option key={data.package_id} value={data.package_id}>{data.package_name}</option>)
    //             })
    //         }
    //     </select>
    // );
}

export default PackagesList;